export default "__VITE_ASSET__BH_4gXmp__"